import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'
import './SuccessToast.scss'
import { ToastPosition } from 'react-bootstrap/ToastContainer'
import { createPortal } from 'react-dom'

const DEFAULT_DELAY = 1500

interface SuccessToastProps {
  message: string
  show: boolean
  onClose: () => void
  position?: ToastPosition
  autohide?: boolean
  delay?: number
  className?: string
}

export const SuccessToast: React.FC<SuccessToastProps> = ({ message, show, onClose, position, autohide, delay, className }) => {
  const toastElement = (
    <ToastContainer position={position || 'bottom-center'} className='p-3 toast-container-fixed' style={{ position: 'fixed', zIndex: 9999 }}>
      <Toast show={show} onClose={onClose} delay={delay ?? DEFAULT_DELAY} className={`success-toast ${className ?? ''}`} autohide={autohide ?? true}>
        <Toast.Body className='d-flex align-items-center'>
          <div className='d-flex align-items-center justify-content-center me-3'>
            <i className='bi bi-check-circle-fill zocks-text-success' />
          </div>
          <span className='flex-grow-1 fw-medium'>{message}</span>
          <div className='separator mx-3'></div>
          <button type='button' className='btn-close btn-close-white' aria-label='Close' onClick={onClose} />
        </Toast.Body>
      </Toast>
    </ToastContainer>
  )
  return createPortal(toastElement, document.body)
}
